import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api/client';

export default function SubscribeConfirm() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('유효하지 않은 링크입니다.');
      return;
    }
    api.get('/api/public/subscribe/confirm', { params: { token } })
      .then(() => {
        setStatus('success');
        setMessage('구독이 완료되었습니다! 새 글이 발행될 때 이메일로 알려드리겠습니다.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || '구독 확인 중 오류가 발생했습니다.');
      });
  }, [token]);

  return (
    <div className="confirm-page">
      {status === 'loading' && <p>구독을 확인하는 중...</p>}
      {status === 'success' && (
        <div className="confirm-success">
          <h2>구독 완료!</h2>
          <p>{message}</p>
          <Link to="/" className="btn-primary">블로그 홈으로</Link>
        </div>
      )}
      {status === 'error' && (
        <div className="confirm-error">
          <h2>오류가 발생했습니다</h2>
          <p>{message}</p>
          <Link to="/">홈으로 돌아가기</Link>
        </div>
      )}
    </div>
  );
}
